import { useState } from 'react'
import { useBrandColors } from '../../hooks/useBrandColors'

const DAYS = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat']
const MONTHS = ['January','February','March','April','May','June','July','August','September','October','November','December']

const eventTypes = {
  company:     { label:'Company Event',  color:'#4A7C59', bg:'rgba(74,124,89,0.1)'    },
  pto:         { label:'PTO',            color:'#8A6640', bg:'rgba(217,195,163,0.3)'  },
  deadline:    { label:'Deadline',       color:'#A0392B', bg:'rgba(160,57,43,0.1)'    },
  newhire:     { label:'New Hire',       color:'#4A6B8A', bg:'rgba(217,195,163,0.15)'   },
  review:      { label:'Review',         color:'#6B7D6B', bg:'rgba(123,94,167,0.1)'   },
  incident:    { label:'Incident',       color:'#C4843A', bg:'rgba(196,132,58,0.1)'   },
  birthday:    { label:'Birthday',       color:'#B8734A', bg:'rgba(184,115,74,0.1)'   },
  anniversary: { label:'Anniversary',    color:'#6B7D6B', bg:'rgba(107,125,107,0.15)' },
  other:       { label:'Other',          color:'#4A4A4A', bg:'rgba(74,74,74,0.08)'    },
}

const initialEvents = [
  { id:1,  date:'2025-04-02', type:'company',   title:'All-Staff Meeting',              time:'9:00 AM',  note:'Conference Room A',         allDay:false },
  { id:2,  date:'2025-04-02', type:'deadline',  title:'Timesheet Deadline - Week 13',   time:'5:00 PM',  note:'All employees',             allDay:false },
  { id:3,  date:'2025-04-05', type:'birthday',  title:'Kim Park - Birthday',            time:'',         note:'',                          allDay:true  },
  { id:4,  date:'2025-04-07', type:'deadline',  title:'Safety Training Due',            time:'5:00 PM',  note:'Module 2',                  allDay:false },
  { id:5,  date:'2025-04-10', type:'company',   title:'Q1 Review - All Departments',    time:'1:00 PM',  note:'Zoom link in memo',         allDay:false },
  { id:6,  date:'2025-04-12', type:'newhire',   title:'Alex Turner - Start Date',       time:'8:00 AM',  note:'Operations dept',           allDay:false },
  { id:7,  date:'2025-04-12', type:'anniversary',title:'Sam Rivera - 3yr Anniversary', time:'',         note:'',                          allDay:true  },
  { id:8,  date:'2025-04-14', type:'company',   title:'Spring Schedule Change',         time:'8:00 AM',  note:'New hours: 8am-4pm',        allDay:false },
  { id:9,  date:'2025-04-15', type:'newhire',   title:'Priya Sharma - Start Date',      time:'8:00 AM',  note:'Field Staff dept',          allDay:false },
  { id:10, date:'2025-04-15', type:'deadline',  title:'PTO Policy Sign-off Due',        time:'5:00 PM',  note:'7 employees outstanding',   allDay:false },
  { id:11, date:'2025-04-22', type:'company',   title:'Employee Appreciation Week',     time:'',         note:'April 22-26',               allDay:true  },
  { id:12, date:'2025-04-23', type:'pto',       title:'Jamie Mitchell - PTO',           time:'All Day',  note:'Approved',                  allDay:true  },
  { id:13, date:'2025-04-24', type:'pto',       title:'Jamie Mitchell - PTO',           time:'All Day',  note:'Approved',                  allDay:true  },
  { id:14, date:'2025-04-25', type:'pto',       title:'Jamie Mitchell - PTO',           time:'All Day',  note:'Approved',                  allDay:true  },
  { id:15, date:'2025-04-28', type:'review',    title:'Marcus Thomas - Check-in',       time:'9:00 AM',  note:'Performance review',        allDay:false },
  { id:16, date:'2025-04-28', type:'birthday',  title:'Jordan Collins - Birthday',      time:'',         note:'',                          allDay:true  },
  { id:17, date:'2025-04-30', type:'deadline',  title:'Monthly Report Due',             time:'5:00 PM',  note:'To Tiffany Gallagher',      allDay:false },
  { id:18, date:'2025-05-01', type:'newhire',   title:'Carlos Mendez - Start Date',     time:'8:00 AM',  note:'Administrative dept',       allDay:false },
  { id:19, date:'2025-05-01', type:'anniversary',title:'Jamie Mitchell - 2yr Anniversary',time:'',      note:'',                          allDay:true  },
  { id:20, date:'2025-05-05', type:'company',   title:'Team Lunch',                     time:'12:00 PM', note:'Downtown Grill',            allDay:false },
]

const blankEvent = { title:'', date:'', time:'', note:'', type:'company', allDay:false }

export default function AdminCalendar() {
  const { accent, accentBg } = useBrandColors()
  const [view, setView] = useState('month')
  const [year, setYear] = useState(2025)
  const [month, setMonth] = useState(3)
  const [weekStart, setWeekStart] = useState(new Date(2025, 3, 6))
  const [events, setEvents] = useState(initialEvents)
  const [filterTypes, setFilterTypes] = useState(Object.keys(eventTypes))
  const [selectedDay, setSelectedDay] = useState(null)
  const [showDayModal, setShowDayModal] = useState(false)
  const [showEventModal, setShowEventModal] = useState(false)
  const [editingEvent, setEditingEvent] = useState(null)
  const [eventForm, setEventForm] = useState(blankEvent)
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(null)
  const [toast, setToast] = useState(null)

  const today = '2025-04-02'

  function showToast(msg) { setToast(msg); setTimeout(()=>setToast(null), 3000) }
  function prevMonth() { month===0?setMonth(11)||setYear(y=>y-1):setMonth(m=>m-1) }
  function nextMonth() { month===11?setMonth(0)||setYear(y=>y+1):setMonth(m=>m+1) }
  function prevWeek() { setWeekStart(d=>{const n=new Date(d);n.setDate(n.getDate()-7);return n}) }
  function nextWeek() { setWeekStart(d=>{const n=new Date(d);n.setDate(n.getDate()+7);return n}) }

  function eventsOn(ds) { return events.filter(e=>e.date===ds&&filterTypes.includes(e.type)) }
  function toggleFilter(type) { setFilterTypes(ft=>ft.includes(type)?ft.filter(t=>t!==type):[...ft,type]) }

  function openAdd(date) {
    setEditingEvent(null)
    setEventForm({...blankEvent, date: date||''})
    setShowEventModal(true)
    setShowDayModal(false)
  }

  function openEdit(ev) {
    setEditingEvent(ev)
    setEventForm({...ev})
    setShowEventModal(true)
    setShowDayModal(false)
  }

  function saveEvent() {
    if (!eventForm.title || !eventForm.date) { alert('Title and date are required.'); return }
    if (editingEvent) {
      setEvents(evs=>evs.map(e=>e.id===editingEvent.id?{...eventForm,id:editingEvent.id}:e))
      showToast('Event updated!')
    } else {
      setEvents(evs=>[...evs, {...eventForm, id:Date.now()}])
      showToast('Event added!')
    }
    setShowEventModal(false)
    setEventForm(blankEvent)
    setEditingEvent(null)
  }

  function deleteEvent(id) {
    setEvents(evs=>evs.filter(e=>e.id!==id))
    setShowDeleteConfirm(null)
    setShowDayModal(false)
    showToast('Event deleted.')
  }

  function handlePrint() {
    const printEvents = events
      .filter(e=>filterTypes.includes(e.type))
      .sort((a,b)=>a.date.localeCompare(b.date))
    const html = `
      <html><head><title>Collective Staff - Calendar</title>
      <style>body{font-family:'Georgia',serif;padding:24px;color:#2B2B2B}h1{font-size:1.4rem;margin-bottom:4px}
      p{font-size:12px;color:#6B7D6B;margin-bottom:20px}.date-header{background:#f5f0ea;padding:6px 12px;font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:0.1em;margin-top:12px;border-left:3px solid #B8734A}
      .event{padding:8px 12px;border-bottom:1px solid #EDE6DA;display:flex;gap:12px;align-items:flex-start}
      .event-type{font-size:9px;padding:2px 6px;border-radius:8px;font-weight:600;flex-shrink:0;margin-top:2px}
      .event-title{font-size:13px;font-weight:600}.event-meta{font-size:11px;color:#6B7D6B;margin-top:2px}
      @media print{body{padding:12px}}</style></head><body>
      <h1>Team Calendar</h1><p>Printed ${new Date().toLocaleDateString('en-US',{month:'long',day:'numeric',year:'numeric'})}</p>
      ${(() => {
        let html = ''; let lastDate = null
        printEvents.forEach(e => {
          const dateLabel = new Date(e.date+'T12:00:00').toLocaleDateString('en-US',{weekday:'long',month:'long',day:'numeric',year:'numeric'})
          if (e.date !== lastDate) { html += `<div class="date-header">${dateLabel}</div>`; lastDate = e.date }
          html += `<div class="event"><div class="event-type" style="background:${eventTypes[e.type].bg};color:${eventTypes[e.type].color}">${eventTypes[e.type].label}</div><div><div class="event-title">${e.title}</div><div class="event-meta">${e.time?e.time+' · ':''}${e.note||''}</div></div></div>`
        })
        return html
      })()}</body></html>`
    const w = window.open('','_blank')
    w.document.write(html)
    w.document.close()
    w.print()
  }

  // Month grid
  const firstDay = new Date(year, month, 1).getDay()
  const daysInMonth = new Date(year, month+1, 0).getDate()
  const daysInPrev = new Date(year, month, 0).getDate()
  const cells = []
  for (let i=0;i<firstDay;i++) cells.push({day:daysInPrev-firstDay+i+1,current:false,ds:null})
  for (let i=1;i<=daysInMonth;i++) { const ds=`${year}-${String(month+1).padStart(2,'0')}-${String(i).padStart(2,'0')}`; cells.push({day:i,current:true,ds}) }
  while (cells.length%7!==0) cells.push({day:cells.length-firstDay-daysInMonth+1,current:false,ds:null})

  // Week days
  const weekDays = Array.from({length:7},(_,i)=>{
    const d=new Date(weekStart); d.setDate(d.getDate()+i)
    const ds=`${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`
    return {d,ds,label:DAYS[d.getDay()],num:d.getDate()}
  })

  // List events
  const listEvents = events.filter(e=>e.date>=today&&filterTypes.includes(e.type)).sort((a,b)=>a.date.localeCompare(b.date))

  const inputStyle = {width:'100%',padding:'8px 12px',border:'1px solid #EDE6DA',borderRadius:6,fontSize:12,fontFamily:"'Montserrat',sans-serif",outline:'none',boxSizing:'border-box'}
  const labelStyle = {display:'block',fontSize:9,textTransform:'uppercase',letterSpacing:'0.1em',color:'#6B7D6B',fontWeight:600,marginBottom:5}

  return (
    <div style={{fontFamily:"'Montserrat',sans-serif"}}>

      {/* Toast */}
      {toast && (
        <div style={{position:'fixed',top:20,right:24,zIndex:2000,background:'#2B2B2B',color:'#fff',padding:'12px 18px',borderRadius:8,fontSize:12,fontWeight:500,boxShadow:'0 4px 20px rgba(0,0,0,0.2)',display:'flex',alignItems:'center',gap:10}}>
          <svg width="14" height="14" viewBox="0 0 16 16" fill="none"><circle cx="8" cy="8" r="6.5" stroke="#4A7C59" strokeWidth="1.5"/><path d="M5 8l2 2 4-4" stroke="#4A7C59" strokeWidth="1.5" strokeLinecap="round"/></svg>
          {toast}
        </div>
      )}

      {/* Delete Confirm */}
      {showDeleteConfirm && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.4)',zIndex:1100,display:'flex',alignItems:'center',justifyContent:'center',padding:24}}>
          <div style={{background:'#fff',borderRadius:12,width:'100%',maxWidth:360,padding:'24px',boxShadow:'0 8px 40px rgba(0,0,0,0.2)',textAlign:'center'}}>
            <div style={{fontSize:32,marginBottom:12}}>🗑️</div>
            <div style={{fontFamily:'Georgia,serif',fontSize:16,fontWeight:600,color:'#2B2B2B',marginBottom:8}}>Delete Event?</div>
            <div style={{fontSize:12,color:'#6B7D6B',marginBottom:20}}>"{showDeleteConfirm.title}" will be permanently deleted.</div>
            <div style={{display:'flex',gap:10,justifyContent:'center'}}>
              <button onClick={()=>setShowDeleteConfirm(null)} style={{padding:'8px 20px',border:'1px solid #EDE6DA',borderRadius:6,background:'#fff',fontSize:12,fontWeight:600,color:'#4A4A4A',cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>Cancel</button>
              <button onClick={()=>deleteEvent(showDeleteConfirm.id)} style={{padding:'8px 20px',border:'none',borderRadius:6,background:'#A0392B',fontSize:12,fontWeight:600,color:'#fff',cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>Delete</button>
            </div>
          </div>
        </div>
      )}

      {/* Add/Edit Event Modal */}
      {showEventModal && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.4)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:24}} onClick={()=>setShowEventModal(false)}>
          <div style={{background:'#fff',borderRadius:12,width:'100%',maxWidth:480,boxShadow:'0 8px 40px rgba(0,0,0,0.18)'}} onClick={e=>e.stopPropagation()}>
            <div style={{padding:'18px 24px',borderBottom:'1px solid #EDE6DA',background:'#2B2B2B',borderRadius:'12px 12px 0 0',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <div style={{fontFamily:'Georgia,serif',fontSize:16,fontWeight:600,color:'#fff'}}>{editingEvent?'Edit Event':'Add Event'}</div>
              <button onClick={()=>setShowEventModal(false)} style={{background:'none',border:'none',fontSize:20,cursor:'pointer',color:'rgba(255,255,255,0.5)',lineHeight:1}}>&times;</button>
            </div>
            <div style={{padding:'20px 24px',display:'flex',flexDirection:'column',gap:14}}>
              <div>
                <label style={labelStyle}>Event Title *</label>
                <input value={eventForm.title} onChange={e=>setEventForm(f=>({...f,title:e.target.value}))} placeholder="Event title..." style={inputStyle}/>
              </div>
              <div>
                <label style={labelStyle}>Event Type *</label>
                <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:6}}>
                  {Object.entries(eventTypes).map(([key,val])=>(
                    <button key={key} onClick={()=>setEventForm(f=>({...f,type:key}))}
                      style={{padding:'6px 8px',border:`2px solid ${eventForm.type===key?val.color:'#EDE6DA'}`,borderRadius:6,background:eventForm.type===key?val.bg:'#fff',color:eventForm.type===key?val.color:'#4A4A4A',fontSize:10,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
                      {val.label}
                    </button>
                  ))}
                </div>
              </div>
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
                <div>
                  <label style={labelStyle}>Date *</label>
                  <input type="date" value={eventForm.date} onChange={e=>setEventForm(f=>({...f,date:e.target.value}))} style={inputStyle}/>
                </div>
                <div>
                  <label style={labelStyle}>Time</label>
                  <input value={eventForm.time} onChange={e=>setEventForm(f=>({...f,time:e.target.value}))} placeholder="e.g. 9:00 AM" style={inputStyle} disabled={eventForm.allDay}/>
                </div>
              </div>
              <label style={{display:'flex',alignItems:'center',gap:8,cursor:'pointer',fontSize:12,color:'#2B2B2B'}}>
                <input type="checkbox" checked={eventForm.allDay} onChange={e=>setEventForm(f=>({...f,allDay:e.target.checked,time:e.target.checked?'All Day':''}))} style={{accentColor:accent,width:14,height:14}}/>
                All day event
              </label>
              <div>
                <label style={labelStyle}>Notes (optional)</label>
                <textarea value={eventForm.note} onChange={e=>setEventForm(f=>({...f,note:e.target.value}))} rows={2} placeholder="Additional details..." style={{...inputStyle,resize:'none'}}/>
              </div>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',paddingTop:4,borderTop:'1px solid #EDE6DA'}}>
                {editingEvent
                  ? <button onClick={()=>setShowDeleteConfirm(editingEvent)} style={{padding:'8px 14px',border:'1px solid #A0392B',borderRadius:6,background:'rgba(160,57,43,0.06)',fontSize:12,fontWeight:600,color:'#A0392B',cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>Delete Event</button>
                  : <div/>
                }
                <div style={{display:'flex',gap:10}}>
                  <button onClick={()=>setShowEventModal(false)} style={{padding:'8px 16px',border:'1px solid #EDE6DA',borderRadius:6,background:'#fff',fontSize:12,fontWeight:600,color:'#4A4A4A',cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>Cancel</button>
                  <button onClick={saveEvent} style={{padding:'8px 20px',background:accent,border:'none',borderRadius:6,color:'#fff',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>{editingEvent?'Save Changes':'Add Event'}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Day Detail Modal */}
      {showDayModal && selectedDay && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.4)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:24}} onClick={()=>setShowDayModal(false)}>
          <div style={{background:'#fff',borderRadius:12,width:'100%',maxWidth:480,maxHeight:'80vh',overflowY:'auto',boxShadow:'0 8px 40px rgba(0,0,0,0.18)'}} onClick={e=>e.stopPropagation()}>
            <div style={{padding:'18px 24px',borderBottom:'1px solid #EDE6DA',background:'#F7F2EB',borderRadius:'12px 12px 0 0',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
              <div style={{fontFamily:'Georgia,serif',fontSize:16,fontWeight:600,color:'#2B2B2B'}}>
                {new Date(selectedDay+'T12:00:00').toLocaleDateString('en-US',{weekday:'long',month:'long',day:'numeric'})}
              </div>
              <button onClick={()=>setShowDayModal(false)} style={{background:'none',border:'none',fontSize:20,cursor:'pointer',color:'#8A9E8A',lineHeight:1}}>&times;</button>
            </div>
            <div style={{padding:'16px 24px'}}>
              {eventsOn(selectedDay).length === 0
                ? <div style={{textAlign:'center',padding:'20px 0',color:'#8A9E8A',fontSize:13}}>No events on this day.</div>
                : eventsOn(selectedDay).map(e=>(
                  <div key={e.id} style={{display:'flex',gap:12,padding:'12px 0',borderBottom:'1px solid #EDE6DA',alignItems:'flex-start'}}>
                    <div style={{width:4,borderRadius:2,background:eventTypes[e.type].color,flexShrink:0,minHeight:40}}></div>
                    <div style={{flex:1}}>
                      <div style={{fontSize:13,fontWeight:600,color:'#2B2B2B',marginBottom:3}}>{e.title}</div>
                      <div style={{display:'flex',gap:8,flexWrap:'wrap',alignItems:'center'}}>
                        {e.time && <span style={{fontSize:11,color:'#6B7D6B'}}>&#128336; {e.time}</span>}
                        <span style={{fontSize:10,padding:'1px 6px',borderRadius:8,background:eventTypes[e.type].bg,color:eventTypes[e.type].color,fontWeight:600}}>{eventTypes[e.type].label}</span>
                      </div>
                      {e.note && <div style={{fontSize:11,color:'#8A9E8A',marginTop:4}}>{e.note}</div>}
                    </div>
                    <button onClick={()=>openEdit(e)} style={{padding:'4px 10px',border:`1px solid ${accent}`,borderRadius:4,background:'transparent',color:accent,fontSize:10,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif",flexShrink:0}}>Edit</button>
                  </div>
                ))
              }
              <button onClick={()=>openAdd(selectedDay)} style={{marginTop:14,width:'100%',padding:'9px',border:`1px dashed ${accent}`,borderRadius:6,background:'transparent',color:accent,fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
                + Add Event to This Day
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Header */}
      <div style={{marginBottom:16,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
        <div>
          <h1 style={{fontFamily:'Georgia,serif',fontSize:'1.4rem',color:'#2B2B2B',fontWeight:600}}>Team Calendar</h1>
          <p style={{fontSize:11,color:'#6B7D6B',marginTop:2}}>Manage company events, deadlines, and team schedules</p>
        </div>
        <div style={{display:'flex',gap:8}}>
          <button onClick={handlePrint} style={{padding:'8px 16px',border:'1px solid #EDE6DA',borderRadius:6,background:'#fff',fontSize:12,fontWeight:600,color:'#4A4A4A',cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
            &#128424; Print
          </button>
          <button onClick={()=>openAdd('')} style={{padding:'8px 18px',background:accent,border:'none',borderRadius:6,color:'#fff',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif"}}>
            + Add Event
          </button>
        </div>
      </div>

      {/* View + filter controls */}
      <div style={{display:'flex',gap:10,marginBottom:14,flexWrap:'wrap',alignItems:'center'}}>
        <div style={{display:'flex',background:'#fff',border:'1px solid #EDE6DA',borderRadius:8,overflow:'hidden'}}>
          {[['month','Month'],['week','Week'],['list','List']].map(([key,label],i,arr)=>(
            <button key={key} onClick={()=>setView(key)}
              style={{padding:'7px 18px',border:'none',borderRight:i<arr.length-1?'1px solid #EDE6DA':'none',background:view===key?accent:'#fff',color:view===key?'#fff':'#4A4A4A',fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif",transition:'all 0.15s'}}>
              {label}
            </button>
          ))}
        </div>
        <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
          {Object.entries(eventTypes).map(([key,val])=>(
            <button key={key} onClick={()=>toggleFilter(key)}
              style={{padding:'4px 10px',border:`1px solid ${filterTypes.includes(key)?val.color:'#EDE6DA'}`,borderRadius:20,background:filterTypes.includes(key)?val.bg:'#fff',color:filterTypes.includes(key)?val.color:'#8A9E8A',fontSize:10,fontWeight:600,cursor:'pointer',fontFamily:"'Montserrat',sans-serif",transition:'all 0.15s'}}>
              {val.label}
            </button>
          ))}
        </div>
        <span style={{marginLeft:'auto',fontSize:11,color:'#8A9E8A'}}>{events.filter(e=>filterTypes.includes(e.type)).length} events</span>
      </div>

      {/* MONTH VIEW */}
      {view === 'month' && (
        <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
          <div style={{padding:'12px 16px',borderBottom:'1px solid #EDE6DA',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
            <button onClick={prevMonth} style={{background:'none',border:'1px solid #EDE6DA',borderRadius:6,padding:'4px 12px',cursor:'pointer',fontSize:14,color:'#4A4A4A'}}>&#8592;</button>
            <div style={{fontFamily:'Georgia,serif',fontSize:16,fontWeight:600,color:'#2B2B2B'}}>{MONTHS[month]} {year}</div>
            <button onClick={nextMonth} style={{background:'none',border:'1px solid #EDE6DA',borderRadius:6,padding:'4px 12px',cursor:'pointer',fontSize:14,color:'#4A4A4A'}}>&#8594;</button>
          </div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',borderBottom:'1px solid #EDE6DA'}}>
            {DAYS.map(d=>(
              <div key={d} style={{textAlign:'center',padding:'8px 4px',fontSize:10,fontWeight:600,color:'#6B7D6B',letterSpacing:'0.08em',textTransform:'uppercase',borderRight:'1px solid #EDE6DA'}}>{d}</div>
            ))}
          </div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)'}}>
            {cells.map((cell,i)=>{
              const evs = cell.ds ? eventsOn(cell.ds) : []
              const isToday = cell.ds === today
              return (
                <div key={i}
                  style={{minHeight:88,padding:'5px',borderRight:'1px solid #EDE6DA',borderBottom:'1px solid #EDE6DA',background:isToday?accentBg:'#fff',cursor:cell.ds?'pointer':'default',opacity:cell.current?1:0.3,transition:'background 0.1s'}}
                  onClick={()=>cell.ds&&(setSelectedDay(cell.ds),setShowDayModal(true))}
                  onMouseEnter={e=>{if(cell.ds&&!isToday)e.currentTarget.style.background='rgba(184,115,74,0.03)'}}
                  onMouseLeave={e=>{if(!isToday)e.currentTarget.style.background='#fff'}}>
                  <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:3}}>
                    <div style={{fontSize:12,fontWeight:isToday?700:400,width:22,height:22,borderRadius:'50%',display:'flex',alignItems:'center',justifyContent:'center',background:isToday?accent:'transparent',color:isToday?'#fff':'#4A4A4A'}}>
                      {cell.day}
                    </div>
                    {cell.ds && (
                      <button onClick={e=>{e.stopPropagation();openAdd(cell.ds)}}
                        style={{width:16,height:16,borderRadius:'50%',border:'none',background:'transparent',color:'#D9C3A3',fontSize:14,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',lineHeight:1,padding:0,opacity:0}}
                        className="add-btn">+</button>
                    )}
                  </div>
                  {evs.slice(0,3).map((e,j)=>(
                    <div key={j}
                      onClick={ev=>{ev.stopPropagation();openEdit(e)}}
                      style={{fontSize:10,padding:'1px 5px',borderRadius:3,marginBottom:1,background:eventTypes[e.type].bg,color:eventTypes[e.type].color,fontWeight:500,whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',borderLeft:`2px solid ${eventTypes[e.type].color}`,cursor:'pointer'}}>
                      {e.title}
                    </div>
                  ))}
                  {evs.length > 3 && <div style={{fontSize:9,color:'#8A9E8A',marginTop:1}}>+{evs.length-3} more</div>}
                </div>
              )
            })}
          </div>
        </div>
      )}

      {/* WEEK VIEW */}
      {view === 'week' && (
        <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
          <div style={{padding:'12px 16px',borderBottom:'1px solid #EDE6DA',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
            <button onClick={prevWeek} style={{background:'none',border:'1px solid #EDE6DA',borderRadius:6,padding:'4px 12px',cursor:'pointer',fontSize:14,color:'#4A4A4A'}}>&#8592;</button>
            <div style={{fontFamily:'Georgia,serif',fontSize:15,fontWeight:600,color:'#2B2B2B'}}>
              Week of {weekDays[0].d.toLocaleDateString('en-US',{month:'short',day:'numeric'})} &mdash; {weekDays[6].d.toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'})}
            </div>
            <button onClick={nextWeek} style={{background:'none',border:'1px solid #EDE6DA',borderRadius:6,padding:'4px 12px',cursor:'pointer',fontSize:14,color:'#4A4A4A'}}>&#8594;</button>
          </div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',borderBottom:'1px solid #EDE6DA'}}>
            {weekDays.map(({d,ds,label,num})=>{
              const isToday = ds===today
              return (
                <div key={ds} style={{borderRight:'1px solid #EDE6DA',padding:'8px 6px',textAlign:'center',background:isToday?accentBg:'#F7F2EB'}}>
                  <div style={{fontSize:9,fontWeight:600,color:'#6B7D6B',textTransform:'uppercase',letterSpacing:'0.08em'}}>{label}</div>
                  <div style={{fontSize:16,fontWeight:isToday?700:400,color:isToday?accent:'#2B2B2B',fontFamily:'Georgia,serif'}}>{num}</div>
                </div>
              )
            })}
          </div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(7,1fr)',minHeight:220}}>
            {weekDays.map(({ds})=>{
              const evs = eventsOn(ds)
              return (
                <div key={ds} style={{borderRight:'1px solid #EDE6DA',padding:'8px 6px',minHeight:220}}
                  onMouseEnter={e=>e.currentTarget.style.background='rgba(184,115,74,0.02)'}
                  onMouseLeave={e=>e.currentTarget.style.background='transparent'}>
                  {evs.map((e,i)=>(
                    <div key={i} onClick={()=>openEdit(e)}
                      style={{fontSize:10,padding:'4px 6px',borderRadius:4,marginBottom:4,background:eventTypes[e.type].bg,color:eventTypes[e.type].color,fontWeight:500,borderLeft:`2px solid ${eventTypes[e.type].color}`,cursor:'pointer',transition:'opacity 0.1s'}}
                      onMouseEnter={ev=>ev.currentTarget.style.opacity='0.8'}
                      onMouseLeave={ev=>ev.currentTarget.style.opacity='1'}>
                      <div style={{fontWeight:600,marginBottom:1,lineHeight:1.3}}>{e.title}</div>
                      {e.time && <div style={{opacity:0.8}}>{e.time}</div>}
                    </div>
                  ))}
                  <button onClick={()=>openAdd(ds)}
                    style={{width:'100%',padding:'4px',border:'1px dashed #EDE6DA',borderRadius:4,background:'transparent',color:'#D9C3A3',fontSize:10,cursor:'pointer',fontFamily:"'Montserrat',sans-serif",marginTop:4}}>
                    +
                  </button>
                </div>
              )
            })}
          </div>
        </div>
      )}

      {/* LIST VIEW */}
      {view === 'list' && (
        <div style={{background:'#fff',border:'1px solid #EDE6DA',borderRadius:10,overflow:'hidden'}}>
          <div style={{padding:'12px 16px',borderBottom:'1px solid #EDE6DA',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
            <div style={{fontFamily:'Georgia,serif',fontSize:15,fontWeight:600,color:'#2B2B2B'}}>All Upcoming Events</div>
            <span style={{fontSize:11,color:'#6B7D6B'}}>{listEvents.length} events</span>
          </div>
          {listEvents.length === 0
            ? <div style={{padding:'40px',textAlign:'center',color:'#8A9E8A',fontSize:13}}>No upcoming events.</div>
            : (() => {
              let lastDate = null
              return listEvents.map(e => {
                const showHeader = e.date !== lastDate
                lastDate = e.date
                const dateLabel = new Date(e.date+'T12:00:00').toLocaleDateString('en-US',{weekday:'long',month:'long',day:'numeric'})
                return (
                  <div key={e.id}>
                    {showHeader && (
                      <div style={{padding:'7px 16px',background:'#F7F2EB',borderBottom:'1px solid #EDE6DA',borderTop:'1px solid #EDE6DA',fontSize:11,fontWeight:600,color:'#6B7D6B',textTransform:'uppercase',letterSpacing:'0.1em'}}>
                        {e.date === today ? 'Today' : dateLabel}
                      </div>
                    )}
                    <div style={{display:'flex',gap:14,padding:'12px 16px',borderBottom:'1px solid #EDE6DA',alignItems:'center',cursor:'pointer',transition:'background 0.1s'}}
                      onClick={()=>openEdit(e)}
                      onMouseEnter={ev=>ev.currentTarget.style.background='rgba(184,115,74,0.03)'}
                      onMouseLeave={ev=>ev.currentTarget.style.background='transparent'}>
                      <div style={{width:4,minHeight:36,borderRadius:2,background:eventTypes[e.type].color,flexShrink:0}}></div>
                      <div style={{flex:1}}>
                        <div style={{display:'flex',justifyContent:'space-between',alignItems:'flex-start'}}>
                          <div style={{fontSize:13,fontWeight:600,color:'#2B2B2B'}}>{e.title}</div>
                          <span style={{fontSize:10,padding:'1px 7px',borderRadius:8,background:eventTypes[e.type].bg,color:eventTypes[e.type].color,fontWeight:600,flexShrink:0,marginLeft:8}}>{eventTypes[e.type].label}</span>
                        </div>
                        <div style={{display:'flex',gap:10,marginTop:3,flexWrap:'wrap'}}>
                          {e.time && <span style={{fontSize:11,color:'#6B7D6B'}}>&#128336; {e.time}</span>}
                          {e.note && <span style={{fontSize:11,color:'#8A9E8A'}}>{e.note}</span>}
                        </div>
                      </div>
                      <button onClick={ev=>{ev.stopPropagation();setShowDeleteConfirm(e)}}
                        style={{padding:'4px 8px',border:'1px solid rgba(160,57,43,0.3)',borderRadius:4,background:'transparent',color:'#A0392B',fontSize:10,cursor:'pointer',fontFamily:"'Montserrat',sans-serif",flexShrink:0}}>
                        Delete
                      </button>
                    </div>
                  </div>
                )
              })
            })()
          }
        </div>
      )}
    </div>
  )
}
